// Menu completo Drago Ramen — 75+ piatti organizzati per categoria
// Prezzi in €. `n` = numero del menu cartaceo. `unit` = unità di vendita (es. "5pz", "1pz").

export const MENU_CATEGORIES = [
  {
    id: "ramen",
    name: "Ramen",
    subtitle: "Fresh Handmade Ramen Noodles",
    kanji: "手工拉面",
    tag: "Signature",
    items: [
      { n: 1, name: "Zuppa di ramen con manzo brasato", nameEn: "Braised Beef Noodles", desc: "Ramen brodo di gallina con manzo brasato, mais, alghe, uovo sodo, verdura", price: 12 },
      { n: 2, name: "Zuppa di ramen con maiale barbecue", nameEn: "Roasted Pork Noodles", desc: "Ramen brodo di gallina con maiale barbecue, mais, alghe, uovo sodo, verdura", price: 12 },
      { n: 3, name: "Ramen al ragù pechinese", nameEn: "Noodles with Peking Meat Sauce", desc: "Ramen al ragù di maiale con salsa pechinese, funghi, carota, cetriolo", price: 11 },
      { n: 4, name: "Zuppa di ramen con costolette di maiale", nameEn: "Pork Ribs Noodles", desc: "Ramen brodo di gallina con costolette di maiale, mais, alghe, uovo sodo, verdura", price: 12 },
      { n: 5, name: "Zuppa di ramen con verdure e uova", nameEn: "Plain Vegetable Ramen", desc: "Ramen brodo di verdura con uova soda, mais, alghe", price: 11 },
      { n: 6, name: "Ramen con coscia di pollo", nameEn: "Chicken Leg Ramen", desc: "Ramen brodo di gallina con coscia di pollo, mais, alghe, uovo sodo, verdura", price: 12 },
      { n: "6a", name: "Ramen con gamberi saltati in padella", nameEn: "Ramen with Pan-Sauteed Shrimp", price: 12 },
      { n: "6b", name: "Ramen con zuppa di gamberi e gamberoni fritti", nameEn: "Ramen with Shrimp Soup and Fried Prawns", price: 12 },
      { n: "6c", name: "Ramen al curry con pollo, patate, carote", nameEn: "Curry Ramen with Chicken, Potatoes, Carrots", price: 12 },
    ],
  },
  {
    id: "ravioli",
    name: "Ravioli & Dumplings",
    subtitle: "Fatti a mano",
    kanji: "饺子",
    tag: "Handmade",
    items: [
      { n: 7,  name: "Ravioli con maiale e funghi", nameEn: "Pork and Mushroom", desc: "Maiale, funghi, carote", price: 6, unit: "5pz", options: ["Al vapore", "Alla griglia"] },
      { n: 8,  name: "Ravioli vegetariani", nameEn: "Vegetarian", desc: "Cavolo, carota, fungo orecchio di Giuda, vermicelli di riso, zucchine", price: 6, unit: "5pz", options: ["Al vapore", "Alla griglia"] },
      { n: 9,  name: "Ravioli con maiale e cavolo cinese sott'aceto", nameEn: "Pork & Pickled Chinese Cabbage", price: 6, unit: "5pz", options: ["Al vapore", "Alla griglia"] },
      { n: 10, name: "Ravioli ai gamberetti", nameEn: "Shrimp", desc: "Gamberi, carne di maiale, carote, sedano", price: 6, unit: "5pz", options: ["Al vapore", "Alla griglia"] },
      { n: 11, name: "Ravioli manzo e cipolla", nameEn: "Beef and Onion", desc: "Manzo, sedano, cipolla", price: 6, unit: "5pz", options: ["Al vapore", "Alla griglia"] },
    ],
  },
  {
    id: "baozi",
    name: "Baozi & Panini",
    subtitle: "Panini cinesi al vapore",
    kanji: "包子",
    tag: "Street food",
    items: [
      { n: 12, name: "Bao di maiale brasato (Cha Siu Bao)", nameEn: "Braised Pork Bao", desc: "Maiale brasato, salsa barbecue cinese, cipolla", price: 3.5 },
      { n: 13, name: "Panino di maiale e funghi", nameEn: "Pork and Mushroom Bun", desc: "Maiale, funghi, carote", price: 3.5 },
      { n: 14, name: "Xiaolongbao (Mini Bao)", nameEn: "Mini Bao", desc: "Maiale, cipolle", price: 6 },
      { n: 15, name: "Su Bao — Ravioli vegetariani", nameEn: "Vegetarian Bao", desc: "Cavolo, carota, fungo orecchio di Giuda, vermicelli di riso, zucchine", price: 3.5 },
      { n: 16, name: "Baozi ripieno di crema pasticcera", nameEn: "Steamed Creamy Custard Bun", desc: "Crema d'uovo, latte, uova", price: 5 },
      { n: 17, name: "Rou Jia Mo — Hamburger cinese", nameEn: "Chinese Hamburger", desc: "Maiale brasato, cipolla e peperone verde crudi", price: 5 },
    ],
  },
  {
    id: "riso",
    name: "Riso",
    subtitle: "Rice / 米饭",
    kanji: "米饭",
    tag: "Wok",
    items: [
      { n: 18, name: "Torta di riso coreana", nameEn: "Korean Rice Cake", desc: "Farina di riso glutinoso, tagliatelle di riso appiccicoso", price: 12 },
      { n: 19, name: "Curry per il riso", nameEn: "Curry Rice", price: 10 },
      { n: 20, name: "Riso cantonese", nameEn: "Guangdong Fried Rice", desc: "Prosciutto, piselli, mais, carote", price: 6 },
      { n: 21, name: "Riso con costolette di maiale", nameEn: "Rice with Pork Ribs", desc: "Costine di maiale, mais, cetriolo, verdure", price: 10 },
      { n: 22, name: "Riso con maiale barbecue", nameEn: "Rice with Roasted Pork", desc: "Maiale brasato, mais, cetriolo, verdure, salsa barbecue", price: 10 },
      { n: 23, name: "Riso con coscia di pollo", nameEn: "Rice with Chicken Leg", desc: "Coscia di pollo, mais, cetriolo, verdure", price: 10 },
      { n: 24, name: "Riso con manzo stufato", nameEn: "Stewed Beef Rice", desc: "Manzo brasato, mais, cetriolo, verdure", price: 10 },
    ],
  },
  {
    id: "carne",
    name: "Carne",
    subtitle: "Meat / 肉类",
    kanji: "肉类",
    tag: "Chef's pick",
    items: [
      { n: 25, name: "Guobaorou — Maiale fritto due volte", nameEn: "Double Cooked Pork", desc: "Filetto di maiale fritto, farina, zucchero, aceto", price: 12 },
      { n: 26, name: "Trippa marinata di manzo", nameEn: "Beef Tripe", desc: "Spezie di filetto di manzo, zucchero, salsa di soia", price: 7 },
      { n: 27, name: "Manzo marinato", nameEn: "Sauced Beef", desc: "Spezie di manzo, zucchero, salsa di soia", price: 8 },
      { n: 28, name: "Piedi di pollo disossati", nameEn: "Boneless Chicken Feet", desc: "Piedi di pollo, olio rosso, zucchero, aceto, aglio, sale", price: 7 },
      { n: 29, name: "Maiale brasato tradizionale", nameEn: "Red-Cooked Pork", desc: "Pancetta di maiale, salsa soia, zucchero, verdura contorno", price: 10 },
      { n: 30, name: "Pollo freddo a fette bollito", nameEn: "Chopped Cold Chicken", desc: "Three yellow soy sauce, scallions, ginger, garlic seasoning", price: 7 },
      { n: 31, name: "Ali di pollo coreane", nameEn: "Korean Chicken Wings", price: 11 },
      { n: 32, name: "Gambe di pollo fritte coreane", nameEn: "Korean Fried Chicken Legs", price: 11 },
      { n: 33, name: "Tempura di gamberi", nameEn: "Tempura Prawns", desc: "Farina e gambero", price: 8 },
    ],
  },
  {
    id: "antipasti",
    name: "Antipasti",
    subtitle: "小菜",
    kanji: "小菜",
    tag: "Da condividere",
    items: [
      { n: 34, name: "Tempura con verdure", nameEn: "Tempura Vegetables", desc: "Carota, zucchine, verdura", price: 6 },
      { n: 35, name: "Alghe Wakame", nameEn: "Wakame Seaweed", price: 5 },
      { n: 36, name: "Insalata di cetriolo", nameEn: "Cucumber Salad", desc: "Succo di cetriolo e aglio", price: 5 },
      { n: 37, name: "Involtini primavera", nameEn: "Spring Rolls", desc: "Cavolo, carote, cipolle", price: 5 },
      { n: 38, name: "Kimchi coreano", nameEn: "Korean Kimchi", desc: "Cavolo piccante coreano, peperoncino", price: 4 },
      { n: 39, name: "Insalata di medusa", nameEn: "Jellyfish Salad", price: 7 },
      { n: 40, name: "Edamame — Fagioli di soia", nameEn: "Edamame", price: 5 },
    ],
  },
  {
    id: "primi",
    name: "Primi",
    subtitle: "Staple Food / 主食",
    kanji: "主食",
    tag: "Piatti forti",
    items: [
      { n: 117, name: "Spaghetti udon saltati", nameEn: "Sauteed Udon Noodles", price: 9 },
      { n: 118, name: "Spaghetti udon saltati con gamberetti", nameEn: "Sauteed Udon with Shrimp", price: 9 },
      { n: 119, name: "Involtini primavera (x3)", nameEn: "Spring Rolls x3", desc: "Cavolo e bastoncini di granchio", price: 5 },
      { n: 120, name: "Noodles al manzo", nameEn: "Beef Noodles", price: 12 },
      { n: 121, name: "Noodles ai gamberi", nameEn: "Shrimp Noodles", price: 7 },
      { n: 122, name: "Ravioli in zuppa", nameEn: "Dumplings with Soup", desc: "Maiale e cipolle verdi", price: 6, unit: "5pz" },
      { n: 123, name: "Ravioli al vapore", nameEn: "Steamed Dumplings", desc: "Maiale e cipolle verdi", price: 6, unit: "5pz" },
      { n: 124, name: "Ravioli fritti", nameEn: "Fried Dumplings", desc: "Maiale e cipolle verdi", price: 6, unit: "5pz" },
      { n: 125, name: "Piadina cinese al maiale", nameEn: "Chinese Flatbread", price: 5 },
      { n: 126, name: "Pane cinese al vapore", nameEn: "Chinese Steamed Bread", desc: "Maiale", price: 3.5 },
      { n: 127, name: "Ravioli al gambero", nameEn: "Shrimp Dumplings", price: 6, unit: "5pz" },
      { n: 128, name: "Patatine fritte", nameEn: "French Fries", price: 4 },
    ],
  },
  {
    id: "spiedini",
    name: "Spiedini",
    subtitle: "Kabob / Grilled Skewers",
    kanji: "烤肉串",
    tag: "Grigliato",
    items: [
      { n: 47, name: "Ali di pollo arrosto", nameEn: "Roast Chicken Wings", price: 3, unit: "1pz" },
      { n: 48, name: "Spiedini di agnello", nameEn: "Lamb Skewer", price: 2, unit: "1pz" },
      { n: 49, name: "Spiedini di manzo", nameEn: "Beef Skewer", price: 2, unit: "1pz" },
      { n: 50, name: "Calamari fritti", nameEn: "Fried Squid", price: 2, unit: "1pz" },
      { n: 51, name: "Artiglio di pollo arrosto", nameEn: "Roast Chicken Claw", price: 1.5, unit: "1pz" },
      { n: 52, name: "Costolette di maiale", nameEn: "Pork Ribs", price: 2, unit: "1pz" },
      { n: 53, name: "Polpa di manzo", nameEn: "Beef Ball", price: 2, unit: "1pz" },
      { n: 54, name: "Pollo marinato", nameEn: "Marinated Chicken", price: 2.5, unit: "1pz" },
      { n: 55, name: "Griglia di pollo fritta", nameEn: "Fried Chicken Rack", price: 1.5, unit: "1pz" },
      { n: 56, name: "Ghiozzo di pollo", nameEn: "Chicken Gizzard", price: 1.5, unit: "1pz" },
      { n: 58, name: "Salsiccia di prosciutto in fiore", nameEn: "Flowering Ham Sausage", price: 1.5, unit: "1pz" },
      { n: 59, name: "Cheese hot dog", nameEn: "Cheese Hot Dog", price: 3, unit: "1pz" },
      { n: 60, name: "Salsiccia di Taiwan", nameEn: "Taiwan Sausage", price: 3, unit: "1pz" },
      { n: 61, name: "Glutine al forno", nameEn: "Baked Gluten", price: 2.5, unit: "1pz" },
      { n: 63, name: "Tofu di pesce", nameEn: "Fish Tofu", price: 1.5, unit: "1pz" },
      { n: "63b", name: "Cavolo Bao Cai", nameEn: "Bao Cai Cabbage", price: 1.5, unit: "1pz" },
      { n: 64, name: "Patate", nameEn: "Potato", price: 1, unit: "1pz" },
      { n: 65, name: "Cavolfiore", nameEn: "Cauliflower", price: 1.5, unit: "1pz" },
      { n: 66, name: "Funghi", nameEn: "Mushroom", price: 1.5, unit: "1pz" },
      { n: 68, name: "Banane fritte", nameEn: "Fried Bananas", price: 3, unit: "1pz" },
      { n: 69, name: "Tofu essiccato aromatizzato", nameEn: "Flavored Dried Tofu", price: 1.5, unit: "1pz" },
      { n: 70, name: "Fette di radice di loto", nameEn: "Lotus Root Slices", price: 1.5, unit: "1pz" },
      { n: 71, name: "Gnocchi cinesi — New Year Cake", nameEn: "New Year Cake", price: 1.5, unit: "1pz" },
    ],
  },
  {
    id: "bevande",
    name: "Bevande & Dolci",
    subtitle: "Drinks and Desserts",
    kanji: "饮品甜点",
    tag: "Bubble tea",
    items: [
      { n: 41, name: "Pear Milk Tea di Hong Kong", nameEn: "Pear Milk Tea", desc: "Tè rosso, latte, zucchero", price: 6 },
      { n: 42, name: "Crema di mango sago freddo con pomelo", nameEn: "Mango Pomelo Sago", price: 7 },
      { n: 43, name: "Tè al latte Jasmine", nameEn: "Jasmine Milk Tea", desc: "Jasmine essiccato, tè rosso, zucchero di canna, latte puro", price: 6 },
      { n: 44, name: "Tè al limone con frutto della passione", nameEn: "Passion Fruit Lemon Tea", desc: "Miele di roccia, tè nero avvolto nel ghiaccio", price: 6 },
      { n: 45, name: "Tè al latte Taro", nameEn: "Taro Milk Tea", desc: "Taro dolce, tè rosa, latte, zucchero, ghiaccio", price: 6 },
    ],
  },
];

// Build a flat map { id: {...} } for quick lookup during cart operations
export const MENU_ITEMS_BY_ID = MENU_CATEGORIES.reduce((acc, cat) => {
  cat.items.forEach((item) => {
    const key = `${cat.id}-${item.n}`;
    acc[key] = { ...item, id: key, category: cat.id, categoryName: cat.name };
  });
  return acc;
}, {});
